import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import Text from '../../../../components/Text';
import TableUI from '../../../../components/TableUI';
import StyleInput from '../../../../components/StyleInput';
import { AutoCompleteSelect } from '../../../../components';
import { AddIcon, CheckIcon, DeleteIcon } from '../../../../components/Icon';
import { ReactComponent as Alarm } from '../../../../static/images/Alarm.svg';
import LongRemark from '../../../../components/LongRemark';
import { Checkbox } from '../../../DutyAssign/components/Attendance/Setting';
import { eadmissionAPI } from '../../../../apis';
import StyleButton from '../../../../components/StyleButton';
import { ADMISSION_SETTING_MAPPING } from '../../../../comm/constant';

const ActionableAlert = ({ admission }) => {
  const classes = useStyles();
  const [actionableList, setActionableList] = useState([]);
  const [alertAlarm, setAlertAlarm] = useState([newAlarm()]);
  const [dropdownList, setDropdownList] = useState([]);
  const rouList = useSelector((state) => state.rouList);
  const timeOptions = [
    {
      text: '',
      value: null,
    },
    {
      text: '5 mins',
      value: 5,
    },
    {
      text: '15 mins',
      value: 15,
    },
    {
      text: '30 mins',
      value: 30,
    },
    {
      text: '60 mins',
      value: 60,
    },
  ];

  const getWardActionableAlertList = async () => {
    try {
      const { result } = await eadmissionAPI.getWardActionableAlertList({ isWard: !admission });
      result.wardActionableAlert?.length > 0 &&
        setActionableList(
          _.map(result.wardActionableAlert, (item) => ({
            ...item,
            expiredByDuration: item.expiredByDuration ?? '',
            expiredByBusStop: item.expiredByBusStop ?? '',
            audioAlertRepeatEvery: item.audioAlertRepeatEvery ?? '',
          }))
        );
      if (result.alertAlarm?.length > 0) {
        setAlertAlarm(result.alertAlarm);
      } else {
        setAlertAlarm([newAlarm()]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardActionableAlertList();
  }, [rouList]);

  const getAlertDropdownList = async () => {
    try {
      const { result } = await eadmissionAPI.getAlertDropdownList();
      setDropdownList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAlertDropdownList();
  }, [rouList]);

  // update actionable
  const handleUpdate = (type, index) => (value) => {
    setActionableList((oldData) => {
      let temp = oldData;
      temp[index][type] = value;
      return [...temp];
    });
  };

  // update alarm
  const handleUpdateAlertAlarm = (type, id) => (value) => {
    setAlertAlarm((preData) =>
      _.map(preData, (item) =>
        item.alarmMappingId === id
          ? {
              ...item,
              [type]: value,
            }
          : item
      )
    );
  };

  // add alarm
  const handleAddAlarm = () => {
    setAlertAlarm((preData) => {
      const maxId = _.get(_.maxBy(preData, 'alarmMappingId'), 'alarmMappingId', 0);
      return [...preData, newAlarm(maxId + 1)];
    });
  };

  // save
  const handleSave = async () => {
    try {
      const params = {
        isWard: !admission,
        wardActionableAlert: _.map(actionableList, (item) => ({
          audioAlertRepeatEvery: item.audioAlertRepeatEvery,
          expiredByBusStop: item.expiredByBusStop,
          expiredByDuration: item.expiredByDuration,
          wardActionableAlertId: item.wardActionableAlertId,
        })),
        wardAlertAlarm: _.filter(
          _.map(alertAlarm, (item) => ({
            alarmMappingId: item.new ? null : item.alarmMappingId,
            alarmStatus: item.alarmStatus,
            machineHostnameIp: item.machineHostnameIp,
            ledAlarm: item.ledAlarm,
            volume: item.volume,
            workstationSpeaker: item.workstationSpeaker,
          })),
          (item) => item.machineHostnameIp
        ),
      };
      await eadmissionAPI.createAlertAlarm(params);
      getWardActionableAlertList();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteAlarm = (alarmMappingId) => () => {
    setAlertAlarm((preData) => _.filter(preData, (item) => item.alarmMappingId !== alarmMappingId));
  };

  return (
    <Box display="flex" flexDirection="column" overflow="auto" width="100%">
      <Text color="#333333" fontSize="1.5rem">
        {actionableList?.[0]?.localtionType}
      </Text>
      <Box display="flex" mt="1rem" mb="1.88rem">
        <Text color="#538FFF" fontSize="1rem" mr="0.5rem">
          #
        </Text>
        <Text color="#7D86A9" fontSize="1rem">
          By default, actionable item will be expired if the case is at Bed Assigned / Withdrawn / Completed after 3
          hours
        </Text>
      </Box>
      <TableUI containerClassName={classes.table}>
        <TableHead className={classes.tableHeader}>
          <TableRow>
            <TableCell style={{ width: '50%' }}>Actionable alert</TableCell>
            <TableCell style={{ width: '10%' }}>Is show</TableCell>
            <TableCell style={{ width: '10%' }}>is ack. req.</TableCell>
            <TableCell style={{ width: '10%' }}>
              Expired by duration <span className={classes.star}>*</span>
            </TableCell>
            <TableCell style={{ width: '10%' }}>
              expired by bus stop step<span className={classes.star}>*</span>
            </TableCell>
            <TableCell style={{ width: '10%' }}>audio alert repeat every</TableCell>
          </TableRow>
        </TableHead>
        <TableBody className={classes.tableBody}>
          {actionableList.map((item, index) => (
            <TableRow key={item.actionableAlert}>
              <TableCell>{ADMISSION_SETTING_MAPPING[item.actionableAlert]}</TableCell>
              <TableCell>{item.isShow ? <CheckIcon className={classes.checkIcon} /> : '-'}</TableCell>
              <TableCell>{item.isAck ? <CheckIcon className={classes.checkIcon} /> : '-'}</TableCell>
              <TableCell>
                <Box display="flex" alignItems="center" gridGap="1rem">
                  <StyleInput
                    className={classes.input}
                    type="number"
                    placeholder=""
                    width="4.25rem"
                    height="3.5rem"
                    padding="0 0.25rem"
                    disabled={!item.isShow || item.isAck ? true : false}
                    value={item.expiredByDuration}
                    onChange={handleUpdate('expiredByDuration', index)}
                  />
                  <Text fontSize="1.125rem" color={!item.isShow || item.isAck ? '#C0C6CB' : '#2E4469'}>
                    mins
                  </Text>
                </Box>
              </TableCell>
              <TableCell>
                {dropdownList[item.actionableAlert] && (
                  <AutoCompleteSelect
                    width="19rem"
                    height="3.5rem"
                    placeholder="Select"
                    disabled={!item.isShow || item.isAck ? true : false}
                    itemList={_.map(dropdownList[item.actionableAlert], (item) => ({
                      text: item,
                      value: item,
                    }))}
                    value={item.expiredByBusStop}
                    onChange={handleUpdate('expiredByBusStop', index)}
                  />
                )}
              </TableCell>
              <TableCell>
                <AutoCompleteSelect
                  width="13.875rem"
                  height="3.5rem"
                  placeholder="Select"
                  disabled={item.isShow ? false : true}
                  itemList={timeOptions}
                  value={item.audioAlertRepeatEvery}
                  onChange={handleUpdate('audioAlertRepeatEvery', index)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableUI>

      <Box mt="2.5rem" display="flex" alignItems="center">
        <Alarm />
        <Text fontSize="1rem" color="#2E4469" ml="0.63rem">
          Workstation for audio alert
        </Text>
        <LongRemark content="Workstation for audio alert" />
      </Box>
      {alertAlarm.map((item) => (
        <Box display="flex" alignItems="center" gridGap="2.5rem" mt="0.75rem" key={item.alarmMappingId}>
          <StyleInput
            width="35rem"
            height="3.5rem"
            value={item.machineHostnameIp}
            onChange={handleUpdateAlertAlarm('machineHostnameIp', item.alarmMappingId)}
          />
          <Box display="flex" alignItems="center" gridGap="0.75rem">
            <Checkbox
              check={item.ledAlarm === 1}
              handleChange={() => handleUpdateAlertAlarm('ledAlarm', item.alarmMappingId)(item.ledAlarm === 1 ? 0 : 1)}
            />
            <Text fontSize="1rem" color="#2E4469">
              LED Alarm
            </Text>
          </Box>
          <Box display="flex" alignItems="center" gridGap="0.75rem">
            <Checkbox
              check={item.workstationSpeaker === 1}
              handleChange={() =>
                handleUpdateAlertAlarm('workstationSpeaker', item.alarmMappingId)(item.workstationSpeaker === 1 ? 0 : 1)
              }
            />
            <Text fontSize="1rem" color="#2E4469">
              Workstation speaker
            </Text>
          </Box>
          <ButtonBase onClick={handleDeleteAlarm(item.alarmMappingId)}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="2.25rem"
              height="2.25rem"
              borderRadius="0.5rem"
              border="1px solid #538FFF"
              bgcolor="#F5FAFF"
            >
              <DeleteIcon className={classes.deleteIcon} />
            </Box>
          </ButtonBase>
        </Box>
      ))}
      <Box display="flex" mt="1.25rem" mb="1.88rem">
        <ButtonBase onClick={handleAddAlarm}>
          <AddIcon className={classes.addIcon} />
          <Text color="#538FFF" fontSize="1rem" ml="0.25rem">
            IP Address or Computer Name
          </Text>
        </ButtonBase>
      </Box>
      <Box display="flex" width="100%" justifyContent="center">
        <StyleButton type="fill" text="Save" onClick={handleSave} />
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  table: {
    '&.MuiTableContainer-root': {
      overflow: 'visible',
      minWidth: '90rem',
    },
  },
  tableHeader: {
    '& .MuiTableCell-head': {
      fontSize: '1rem !important',
      padding: '0 2.5rem 1.19rem 0 !important',
    },
  },
  tableBody: {
    '& .MuiTableCell-body': {
      fontSize: '1.125rem !important',
      padding: '1rem 2.5rem 1rem 0 !important',
    },
  },
  star: {
    fontSize: '1rem',
    color: '#FF0300',
  },
  checkIcon: {
    fontSize: '1.25rem',
    color: '#28D2AB',
  },
  addIcon: {
    fontSize: '1rem',
    color: '#538FFF',
  },
  input: {
    '& .MuiInputBase-input': {
      textAlign: 'center',
    },
  },
  deleteIcon: {
    fontSize: '1.5rem',
    color: '#538FFF',
  },
}));

const newAlarm = (id) => ({
  alarmMappingId: id ?? 0,
  alarmStatus: 0,
  machineHostnameIp: '',
  ledAlarm: 0,
  volume: 0,
  workstationSpeaker: 0,
  new: true,
});

export default ActionableAlert;
